export default __webpack_public_path__ + "static/media/EM0370.34I-22414_-15113_0.31e2a095.jpg";